export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-background-50/20 blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-accent-400/20 blur-3xl"></div>
          </div>
          <div className="relative flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">移动看片，随时随地</h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-lg">
                日韩影视网全面适配手机和平板，无需下载APP，打开浏览器即可畅享免费日韩电影在线观看。高清画质自适应，流量模式下自动优化，上班通勤、睡前追剧，随时随地想看就看。
              </p>
              <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 text-background-50 text-sm whitespace-nowrap">
                  <i className="ri-smartphone-line text-lg"></i>
                  手机浏览器打开即用
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 text-background-50 text-sm whitespace-nowrap">
                  <i className="ri-qr-code-line text-lg"></i>
                  扫码收藏到桌面
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-80 md:w-56 md:h-[360px] rounded-2xl bg-background-50/10 border border-background-50/20 overflow-hidden backdrop-blur-sm">
                <div className="h-8 bg-background-50/10 flex items-center justify-center">
                  <div className="w-20 h-1 rounded-full bg-background-50/20"></div>
                </div>
                <div className="p-4 space-y-3">
                  <div className="h-28 rounded-lg bg-background-50/10"></div>
                  <div className="h-3 w-3/4 rounded bg-background-50/10"></div>
                  <div className="h-3 w-1/2 rounded bg-background-50/10"></div>
                  <div className="h-28 rounded-lg bg-background-50/10 mt-4"></div>
                  <div className="h-3 w-3/4 rounded bg-background-50/10"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}